import React, { createContext } from "react";
import { ActionName } from "types/common";

type ModalContextType = {
  modalType: any;
  setModalType: any;
  showProjects: boolean;
  setShowProjects: React.Dispatch<React.SetStateAction<boolean>>;
  showKeyGuide: boolean;
  setShowKeyGuide: React.Dispatch<React.SetStateAction<boolean>>;
  serversModalShown: boolean;
  setServersModalShown: React.Dispatch<React.SetStateAction<boolean>>;
  cracModalShown: boolean;
  setCracModalShown: React.Dispatch<React.SetStateAction<boolean>>;
  rppModalShown: boolean;
  setRppModalShown: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ModalContext = createContext<ModalContextType>({
  modalType: '',
  setModalType: () => { },
  showProjects: false,
  setShowProjects: () => { },
  showKeyGuide: false,
  setShowKeyGuide: () => { },
  serversModalShown: false,
  setServersModalShown: () => { },
  cracModalShown: false,
  setCracModalShown: () => { },
  rppModalShown: false,
  setRppModalShown: () => { },
});

const ModalProvider = ({ children }: any) => {
  const [modalType, setModalType] = React.useState<ActionName | ''>('');
  const [showProjects, setShowProjects] = React.useState<boolean>(false);
  const [showKeyGuide, setShowKeyGuide] = React.useState<boolean>(false);
  const [serversModalShown, setServersModalShown] = React.useState<boolean>(false);
  const [cracModalShown, setCracModalShown] = React.useState<boolean>(false);
  const [rppModalShown, setRppModalShown] = React.useState<boolean>(false);

  return (
    <ModalContext.Provider value={{ modalType, setModalType, showProjects, setShowProjects, showKeyGuide, setShowKeyGuide, serversModalShown, setServersModalShown, cracModalShown, setCracModalShown, rppModalShown, setRppModalShown }}>
      {children}
    </ModalContext.Provider>
  );
};

export default ModalProvider;
